import { useMemo } from "react";
import { HomepageOrder } from "@fdr/types/ts/Home";
import useExperiments from "../../useExperiments";
import { EXPERIMENT_KEY, DEPLOYMENT_KEY } from "./constants";
import { VariantEnum } from "./types";
import { getNewOrder } from "./utils";

export const usePopularAndTodaysRacesOrder = (baseOrder: HomepageOrder) => {
  const { getVariant } = useExperiments(DEPLOYMENT_KEY);

  const variant = getVariant<VariantEnum, boolean>(EXPERIMENT_KEY);

  const parsedOrder = useMemo(
    () => getNewOrder(baseOrder, !!variant?.payload),
    [baseOrder, JSON.stringify(variant)]
  );

  return parsedOrder;
};
